import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {homepageMock} from './Luck/mock'

// 获取用户页面详情信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=132052625
export const holy_week_homepage = createAsyncThunk(
  'live/activity/holy_week_homepage',
  async (arg, store: any) => {
    // return homepageMock
    const resp = await http.post(
      'live/activity/holy_week_homepage',
      {},
      {
        store: window.store,
      }
    )
    return resp.data.data
  }
)

interface recordItem {
  member?: {
    name?: string
    mid?: number
    avatar?: string
  }
  cardName?: string
  status?: number
  timeStr?: string // 0 为可赠送，1为已赠送
}
interface cardItem {
  id?: number
  img?: string
  name?: string
  num?: number
}

interface myHistoryItem {
  reward_id: number
  gift_icon: string
  win_time: string
  recv_time: string
  gift_value: number
  gift_name: string
}

interface areaRecordItem {
  member_mid: number
  member_avatar: string
  gift_icon: string
  gift_value: number
  win_time: string
}

interface InitialStateType {
  my_win_cnt?: number // 我的免单次数
  my_history?: myHistoryItem[] // 免单历史
  free_order_status?: number // 免单 0-未开启；1-进行中
  count_down?: number // 免单未开启时为距离免单活动开始倒计时；免单开始后为距离免单结束倒计时
  area_record?: areaRecordItem[] // 播报
}

const initialState: InitialStateType = {}

export const HWFestivalSlice = createSlice({
  name: 'HWFestival',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(holy_week_homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default HWFestivalSlice.reducer
export const HWFestivalActions = HWFestivalSlice.actions
